import { ImageFieldProps, sanitizeFieldRestProps, useFieldValue } from "react-admin";
import get from 'lodash/get';
import { Box, Typography } from "@mui/material";


export interface MyImageFieldProps extends Omit<ImageFieldProps, "src"> {
    getSrc?: (source: any) => string | undefined
}

export const ImageFieldExt = (props: MyImageFieldProps) => {
    const {
        getSrc = (x) => x,
        className,
        // classes: classesOverride,
        emptyText, record, title, ...rest
    } = props;
    const value = useFieldValue(props);
    const sourceValue = getSrc(value);
  

    if (!sourceValue) {
        return emptyText ? (
            <Typography component="span" variant="body2" className={className}
                {...sanitizeFieldRestProps(rest)}
            >
                {emptyText}
            </Typography>
        ) : (
            <Box className={className} {...sanitizeFieldRestProps(rest)} />
        );
    }

    const titleValue = get(record, title!) || title;

    return (
        <Box className={className} {...sanitizeFieldRestProps(rest)}>
            <img
                title={titleValue}
                alt={titleValue}
                src={sourceValue}
                style={{ margin: '0.3rem', maxHeight: '4rem', }}
            />
        </Box>
    );
}